import * as GLOBAL_LABELS from "../labels/global";

export const LABELS = {
    [GLOBAL_LABELS.GLOBAL_DELETE]: "Delete",
    [GLOBAL_LABELS.GLOBAL_CANCEL]: "Cancel",
    [GLOBAL_LABELS.GLOBAL_UNKNOWN]: "Unknown",

    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_TEST_MODE]: "测试模式",
    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_LIVE_TEST_MODE]: "正式测试模式",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_MESSAGE]: "本次结账处于{mode}状态。不会实际进行付款。",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_BUTTON]: "我明白了",
};

export default LABELS;
